/**
 * Time unit associated with the provision's tenor period.
 * tag: 40097
 * @readonly
 * @enum {string} (String)
 */
export enum ProvisionDateTenorUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
